import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Tabs } from 'antd'
import { ACTION } from '../../../../utils/constants'
import InfoForm from './InfoForm'
import ConditionForm from './ConditionForm'
import WebhookTab from '../BrandActivityDetail/WebhookTab'

const { TabPane } = Tabs

const BrandActivityForm = (props) => {
  const {
    visible,
    onOk,
    onCancel,
    form,
    action,
    formState,
    onRemoveImage,
    coverList,
    setCoverList,
    removedImages,
    setRemovedImages,
    webhookDrafts,
    setWebhookDrafts
  } = props
  const [activeTab, setActiveTab] = useState('general')
  const activityId = formState && formState.id

  useEffect(() => {
    if (visible) {
      setActiveTab('general')
    }
  }, [visible])

  return (
    <Modal
      width={1000}
      title={`${action} a Brand Activity`}
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      footer={null}>
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <TabPane tab="ทั่วไป" key="general">
          <InfoForm
            action={action}
            onCancel={onCancel}
            form={form}
            formState={formState}
            onOk={onOk}
            onRemoveImage={onRemoveImage}
            coverList={coverList}
            setCoverList={setCoverList}
            removedImages={removedImages}
            setRemovedImages={setRemovedImages}
          />
        </TabPane>
        <TabPane tab="การแจ้งเตือน" key="notification">
          {visible && (
            <WebhookTab
              brandActivityId={activityId}
              drafts={webhookDrafts}
              onDraftsChange={setWebhookDrafts}
            />
          )}
        </TabPane>
      </Tabs>

      {/* {action === ACTION.CREATE ? (
        <InfoForm action={action} onCancel={onCancel} onOk={onOk} />
      ) : (
        <Tabs defaultActiveKey="1">
          <TabPane tab="Brand Activity Info" key="1">
            <InfoForm
              action={action}
              onCancel={onCancel}
              form={form}
              formState={formState}
              onOk={onOk}
            />
          </TabPane>
          <TabPane tab="Brand Activity Condition" key="2">
            <ConditionForm
              action={action}
              onCancel={onCancel}
              form={form}
              formState={formState}
              onOk={onOk}
            />
          </TabPane>
        </Tabs>
      )} */}
    </Modal>
  )
}

BrandActivityForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  action: PropTypes.string.isRequired,
  formState: PropTypes.any,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  coverList: PropTypes.array.isRequired,
  setCoverList: PropTypes.func.isRequired,
  removedImages: PropTypes.array.isRequired,
  setRemovedImages: PropTypes.func.isRequired,
  webhookDrafts: PropTypes.array.isRequired,
  setWebhookDrafts: PropTypes.func.isRequired
}

const WrappedBrandActivityForm = Form.create({
  name: 'BrandActivityForm'
})(BrandActivityForm)
export default WrappedBrandActivityForm
